import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Actions as PAYSLIPACTIONS } from "../../store/actions/payslipActions";
import ImportPayrollHistoryRow from "./ImportPayrollHistoryRow";
import { ArrowDownTrayIcon } from "@heroicons/react/20/solid";
import { CSVLink } from "react-csv";

const ImportPayrollHistoryModal = ({
	isModalOpen,
	showImportModal,
	getPayslipImportTemplate,
	uploadFile,
	handlePayslipUpload,
	org,
	uploadKey,
	uploading,
	processing,
	uploadTemplate,
	uploadResults,
}) => {
	const ButtonManager = () => {
		return (
			<>
				{uploadResults.errors || uploadResults.warnings ? (
					<CSVLink
						filename="Payslip Import Errors.csv"
						className="btn btn-success pull-right"
						style={{ marginBottom: 20 }}
						data={errors}
					>
						<ArrowDownTrayIcon
							className="w-6 h-6 mr-3"
							style={{ verticalAlign: "text-bottom" }}
						/>
						Download Error Report
					</CSVLink>
				) : (
					""
				)}
			</>
		);
	};

	const [file, setFile] = useState(false);
	const [errors, setErrors] = useState([["Row", "Type", "Message"]]);

	useEffect(() => {
		if (isModalOpen) {
			getPayslipImportTemplate();
		}
	}, [isModalOpen]);

	useEffect(() => {
		if (file && uploadResults) {
			setFile(null);
		}
		if (uploadResults.errors || uploadResults.warnings) {
			let newErrors = [["Row", "Type", "Message", "Expected Value", "Actual Value"]];

			uploadResults.processed
				.filter((i) => i.error || i.warnings)
				.map((item) => {
					if (item.error) {
						if (item.error.fields) {
							Object.keys(item.error.fields || {})?.map((f) => {
								const field = item.error?.fields[f];
								newErrors.push([
									item.rowNumber,
									"Error",
									`The field ${f} is not validating.`,
									field?.expected,
									field?.actual,
								]);
							});
						} else {
							newErrors.push([item.rowNumber, "Error", item.error.message]);
						}
					} else if (item.warnings) {
						item.warnings.map((i) => {
							newErrors.push([item.rowNumber, "Warning", i.message]);
						});
					}
				});
			setErrors(newErrors);
		}
	}, [uploadResults]);

	const selectUploadFile = (e) => {
		const file = e.target.files[0]; // accessing file
		// console.log('file', file);
		setFile(file); // storing file
		uploadFile(file);
	};

	const processUploadFile = () => {
		handlePayslipUpload(uploadKey, org);
	};

	if (!isModalOpen) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "50%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										onClick={showImportModal}
										data-dismiss="modal"
										type="button"
									>
										<XMarkIcon className="h-6 w-6 text-white" />
									</button>
								</li>
							</ul>
							<h3
								className="block-title"
								style={{ marginLeft: 10 }}
							>
								Import Payroll History
							</h3>
						</div>
						<div
							className="block-content"
							style={{ marginRight: "30px", marginLeft: "30px", marginTop: "10px" }}
						>
							{((uploadResults?.errors || uploadResults?.processed) && (
								<div>
									{(uploadResults?.processed.length > 0 && (
										<div className="col-xs-6 pl-0">
											{uploadResults?.processed?.length - uploadResults?.errors} payslip
											{uploadResults?.processed?.length - uploadResults?.errors != 1
												? "s were"
												: " was"}{" "}
											imported.
										</div>
									)) ||
										""}
									<div className="col-xs-6 pr-0">
										<ButtonManager />
									</div>
									{(uploadResults?.errors && (
										<div>
											There {uploadResults.errors > 1 ? "were" : "was"} {uploadResults.errors}{" "}
											error{uploadResults.errors > 1 ? "s" : ""} with the imported file. The
											following row{uploadResults.errors > 1 ? "s were" : " was"} not saved.
											<div
												className="table-responsive"
												style={{ marginBottom: 20 }}
											>
												<table className="js-table-sections table table-hover">
													<thead>
														<tr>
															<th>Row</th>
															<th>Error</th>
														</tr>
													</thead>
													<tbody>
														{uploadResults?.processed
															?.filter((i) => i.error)
															?.map((item) => (
																<ImportPayrollHistoryRow item={item} />
															))}
													</tbody>
												</table>
											</div>
										</div>
									)) ||
										""}
									{(uploadResults?.warnings && (
										<div>
											We identified {uploadResults.warnings} potential mistake
											{uploadResults.warnings > 1 ? "s" : ""} with the imported file.
											<div
												className="table-responsive"
												style={{ marginBottom: 20 }}
											>
												<table className="js-table-sections table table-hover">
													<thead>
														<tr>
															<th>Row</th>
															<th>Warning</th>
														</tr>
													</thead>
													<tbody>
														{uploadResults?.processed
															?.filter((i) => i.warnings)
															?.map((item) => (
																<ImportPayrollHistoryRow item={item} />
															))}
													</tbody>
												</table>
											</div>
										</div>
									)) ||
										""}
									<button
										className="btn btn-default"
										onClick={showImportModal}
										style={{ marginBottom: 20 }}
									>
										Close
									</button>
									<ButtonManager />
								</div>
							)) || (
								<div>
									<p>
										Here's how to import your entire payroll history in 3 easy steps: just download
										our ready-made Excel sheet template, paste in your data in the corresponding
										columns, and upload it back when you're done.
									</p>
									<p>
										{(uploadTemplate && (
											<a
												target="_blank"
												href={`${uploadTemplate}`}
											>
												Download Template (.xlsx)
											</a>
										)) || <span>Loading Excel Template...</span>}
										<br />
										<a
											href="https://support.buddy.hr/hc/en-mt/articles/360012041199-Importing-Previous-Payrolls-into-Buddy"
											target="_blank"
										>
											Guide - How to fill in
										</a>
									</p>
									<div className="row block buttons">
										<div className="col-sm-4">
											<label
												htmlFor="uploadPayslips"
												className="btn btn-success"
												style={{ display: "inline-block", marginLeft: "10px" }}
											>
												<i className="fa fa-upload"></i>&nbsp;
												{uploading ? "Uploading..." : "Upload File"}
											</label>
											<input
												style={{ display: "none" }}
												id="uploadPayslips"
												type="file"
												accept=".xlsx"
												onChange={selectUploadFile}
											/>
											<input
												id="upload_payslips"
												type="file"
											/>
										</div>
										<div className="col-sm-3">
											{uploadKey && (
												<button
													id="import_payslips"
													disabled={processing}
													className="btn btn-default"
													onClick={() => processUploadFile()}
												>
													{processing ? "Importing..." : "Start Import"}
												</button>
											)}
										</div>
										<div className="clearfix" />
									</div>
									<div className="clearfix" />
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		uploadResults: state.payslipImport.results,
		isModalOpen: state.payslipImport.showModal,
		processing: state.payslipImport.processingFile,
		uploading: state.payslipImport.uploading,
		uploadTemplate: state.payslipImport.template,
		uploadKey: state.payslipImport.uploadResults,
		org: state.company.settings.org,
	};
};

const mapDispatchToProps = (dispatch) => ({
	uploadFile: (file) => dispatch(PAYSLIPACTIONS.uploadFile({ file })),
	handlePayslipUpload: (key, org) => dispatch(PAYSLIPACTIONS.handlePayslipUpload({ key, org })),
	getPayslipImportTemplate: () => dispatch(PAYSLIPACTIONS.getPayslipImportTemplate()),
	showImportModal: () => dispatch(PAYSLIPACTIONS.showImportModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportPayrollHistoryModal);
